import React from 'react';
import { callAll } from 'Utils';
import { useTranslation } from 'react-i18next';
import { FormikFieldString } from 'Components/FormikComponents';
import { NameInputType } from './formTypes';

type Props = {
    formikProps: NameInputType;
    error?: any;
    resetError: () => void;
    className?: string;
};

const ListNameInput = ({ formikProps, error, resetError, className }: Props) => {
    const { t } = useTranslation();
    const { handleBlur, handleChange, errors, touched, setFieldTouched } = formikProps;
    return (
        <FormikFieldString
            className={className}
            name='name'
            label={t('List Name')}
            handleChange={callAll(() => setFieldTouched('name'), resetError, handleChange)}
            handleBlur={handleBlur}
            error={!!(errors.name && touched.name) || error?.data?.error?.param === 'name'}
            errorMsg={errors.name ?? error?.data?.error?.message}
            optionalMsg={t('validation.unique', { field: t('List Name') })}
        />
    );
};

export default ListNameInput;
